import { FilterTypeModel } from './abstract-filter-type.model';
import { FilterTypesEnum } from '../enums/filters-types.enum';
import { ChipModel } from '../../Forms/models/chip.model';
import { DateQueryModel } from '../../Forms/models/date-query.model';
import { DateQueryTypeEnum } from '../../../api/mentions/enum/date-query-type.enum';
import { DropdownOptionModel } from '../../Forms/models/dropdown-option.model';
import { DateHelper } from '../../Forms/helpers/date.helper';
import { getDefaultDateInputOptionValuesModel } from '../../../Common/Forms/models/date-query-input-options.model';

export class FilterTypeDateQueryModel  extends FilterTypeModel<DateQueryModel> {
    readonly key: FilterTypesEnum = FilterTypesEnum.dateQuery;

    declare options: DropdownOptionModel[];

    value: DateQueryModel;
    currentValue: DateQueryModel;

    constructor(
        id: string,
        label: string,
        options: DropdownOptionModel[] = getDefaultDateInputOptionValuesModel(),
        value?: DateQueryModel
    ) {
        super(id, label);

        this.options = options;
        this.setValue(value || DateQueryModel.getAllQuery());
    }

    /**
     * Makes a chip from a range
     * @param val A range
     */
    private makeChip(val: DateQueryModel): ChipModel|null {
        if (val.type === DateQueryTypeEnum.ALL) {
            return null;
        } else if (val.type === DateQueryTypeEnum.ABSOLUTE) {
            const tz = val.timezone;
            if (val.absoluteDate) {
                return {
                    label: DateHelper.toDateString(val.absoluteDate, tz)
                };
            } else {
                return {
                    label: DateHelper.toDateString(val.absoluteRange.start, tz) + ' - ' + DateHelper.toDateString(val.absoluteRange.end, tz)
                };
            }
        }
        const thing = getDefaultDateInputOptionValuesModel().find(
            option => DateQueryModel.equals(option.value.query, val)
        );
        if (!thing) {
            return null;
        }
        return {
            label: thing.label
        };
    }

    /**
     * Sets the active value for a filter
     * @param value
     */
    setValue(value: DateQueryModel): void {
        this.value = value;
        this.chips = [];
        const chip = this.makeChip(this.value);
        if (chip) {
            this.chips.push(chip);
        }
        this.cancelChanges();
    }

    /**
     * Gets the active value for a filter
     */
    getValue(): DateQueryModel {
        return this.value;
    }

    /**
     * Handles deleting a chip for the active value of this filter
     * @param chip A chip from this filter
     */
    removeChip(chip: ChipModel): void {
        this.setValue(DateQueryModel.getAllQuery());
    }

    /**
     * Resets the filter to not apply any changes
     */
    clear(): void {
        this.setValue(DateQueryModel.getAllQuery());
    }

    /**
     * Sets the current value for a filter
     * @param value
     */
    setCurrentValue(value: DateQueryModel): void {
        this.currentValue = value;
        this.currentChips = [];
        const chip = this.makeChip(this.currentValue);
        if (chip) {
            this.currentChips.push(chip);
        }
    }

    /**
     * Gets the current value for a filter
     */
    getCurrentValue(): DateQueryModel {
        return this.currentValue;
    }

    /**
     * Handles deleting a chip for the current value of this filter
     * @param chip A chip from this filter
     */
    removeCurrentChip(chip: ChipModel): void {
        this.setCurrentValue(DateQueryModel.getAllQuery());
    }

    /**
     * Resets the current value to the active value
     */
    cancelChanges(): void {
        this.setCurrentValue(this.getValue());
    }
}
